<div class="link-input-row" cdkOverlayOrigin #overlayOrigin="cdkOverlayOrigin">
  <dojo-text-input class="flex-1" [formCtrl]="formCtrl" [label]="label" [placeholder]="placeholder" />

  @if (hasOptions()) {
    <dojo-icon-button
      class="options-button"
      [icon]="'list'"
      [size]="'xs'"
      [dojoTooltip]="'examdojo.popover.search_existing_links' | transloco"
      (click)="toggleDropdown()"
    />
  }
</div>

@if (matchedLabel(); as label) {
  <div class="matched-label">
    <dojo-icon [icon]="'link'" [size]="'2xs'" />
    @if (hasResolver) {
      <a class="dashed-link matched-label-link" (click)="resolveLink()">{{ label }}</a>
    } @else {
      {{ label }}
    }
  </div>
}

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="overlayOrigin"
  [cdkConnectedOverlayOpen]="dropdownOpen()"
  [cdkConnectedOverlayOffsetY]="4"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
  (backdropClick)="closeDropdown()"
  (detach)="closeDropdown()"
>
  <div @dropdownAnimation class="options-dropdown" cdkTrapFocus [cdkTrapFocusAutoCapture]="true" dojoStopPropagation>
    <input
      class="options-filter"
      [formControl]="filterCtrl"
      [placeholder]="'examdojo.popover.search_options' | transloco"
      (keydown)="onFilterKeyDown($event)"
    />

    <div class="options-list" role="listbox">
      @for (option of filteredOptions(); track option.value) {
        <button
          dojoSmartLinkOption
          class="option-item"
          type="button"
          role="option"
          (click)="selectOption(option)"
          dojoStopPropagation
        >
          {{ option.label }}
        </button>
      } @empty {
        <div class="option-empty">
          {{ 'examdojo.popover.no_options' | transloco }}
        </div>
      }
    </div>
  </div>
</ng-template>
